import React, {useState} from "react";
import { Button, Col, FormGroup, Modal, Row, Container} from "react-bootstrap";
import { Form, Checkbox , Select, Input } from 'antd';
import { Link } from "react-router-dom";
import TextArea from "antd/lib/input/TextArea";
import { ImageElement,Breadcrumb, LoginHeader} from "../../components";
// import TextArea from "antd/lib/input/TextArea";
const handleChange = (value) => {
    console.log(`selected ${value}`);
};

function ServiceProviderList() {

    const breadcrumb = [
        {
            path: '/dashboard',
            name: 'Home',
        },
        {
            path: '#',
            name: 'Service Provider List',
        },
    ];
    const [showbookdetail, setDetail] = useState(false);
    const bookdetailClose = () => setDetail(false);
    const BookDetailShow = () => {setDetail(true)};

    const [showRequested, setRequested] = useState(false);
    const RequestedClose = () => setRequested(false);
    // const RequestedShow = () => {setRequested(true)};
    const RequestedShow = () =>{
        bookdetailClose(false)
        setRequested(true)
    };
    return(
        <>            
            <LoginHeader/>         
            <div className="main-content ServiceProviderPage">
                {/* page content */}
                <div className="pageContent">
                    <Container className="container-lg">
                        <Breadcrumb title="Book Appointment" breadcrumb={breadcrumb}/>
                        {/* Service Address */}
                        <div className="bookAppointment bg-white p-30 br-10 mb-3">
                            <div className="d-sm-flex align-items-center flex-wrap justify-content-between">
                                <div className="bookAppointment_left">
                                <Button variant="primary" onClick={BookDetailShow} className="btnAppointment">book appointment now</Button>
                                    <span className="font-md mt-1 d-inline-block">Or you can pick a specific technician below</span>
                                </div>
                                <div className="d-flex btns-group">
                                <Link to="/qanca-service-provider-map"  className="btn btn-light text-capitalize"><em className="gg-marker me-2" />Map</Link>
                                <Link to="" className="btn btn-info text-capitalize"><em className="gg-list me-2" />List</Link>
                                </div>                                            
                            </div>
                        </div>
                        <div className="serviceAddress BookAppointmentPage">
                            <div className="d-flex align-items-md-center flex-md-row flex-column flex-wrap">
                                <div className="serviceAddress_left">
                                <h2 className="text-850 font-sm">Service Address</h2>
                                    <p className="mb-0">Vijay Nagar Square, Vijay Nagar, Indore, Madhya Pradesh, India</p>
                                </div>
                                <div className="serviceAddress_right mt-md-0 mt-2 ms-md-auto">
                                    <div className="d-flex align-items-center">
                                        <Form>
                                            <FormGroup className="form-group d-flex align-items-center flex-wrap mb-0">
                                                <Form.Item
                                                    label="Sort By"
                                                    className="mb-0 font-md"
                                                    >
                                                    <Select
                                                        defaultValue="serviceProvider1"
                                                        onChange={handleChange}
                                                        className="w-100 ant-select-lg"
                                                        options={[
                                                            {
                                                            value: 'serviceProvider1',
                                                            label: 'All Service Provider',
                                                            },
                                                            {
                                                            value: 'serviceProvider2',
                                                            label: 'Favorite Service Provider',
                                                            },
                                                        ]}
                                                        />
                                                </Form.Item>
                                                {/* <Button variant="primary" type="submit" className="font-md">Emergency Request to all</Button> */}
                                            </FormGroup>
                                        </Form>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* Service Address */}
                        <div className="appointmentSection bg-white p-30 br-10">
                            <Row className="g-3">
                            {/* EMPTY SCREEN_______ */}
                                {/* <Col sm={12}> 
                                    <div className="noList m-auto text-center d-flex align-items-center justify-content-center">
                                        <div className="noList_inner">
                                            <ImageElement source="no-booking.svg" className="img-fluid"/>
                                            <div className="noList_cnt">
                                                <h5>No Booking Appointment</h5>
                                                <p className="mb-0">Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
                                            </div>
                                        </div>                                
                                    </div> 
                                </Col> */}
                                <Col sm={6} lg={4} xxl={3}>
                                    <div className="appointmentList position-relative"> 
                                        <div className="appointmentList_like">
                                            <Checkbox defaultChecked><em className="appointmentList_like_icon gg-heart-outline" /></Checkbox>
                                        </div>
                                        <div className="appointmentList_top d-flex align-items-start">
                                            <div className="appointmentList_top_images">
                                                <ImageElement source="img-1.png" />
                                            </div>
                                            <div className="appointmentList_top_content">
                                                <h2 className="font-md">Steven S. Hurd</h2>
                                                <p className="">HVAC</p>
                                                <ul className="list-inline mb-0">
                                                    <li className="list-inline-item">
                                                        <div className="info">
                                                            <ul className="list-unstyled d-flex starRating mb-0">
                                                                <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                                                <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                                                <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                                                <li className="starRating_halfStar"><em className="info_icon info_icon-gray gg-half-star active_half"/></li>
                                                                <li><em className="info_icon info_icon-gray gg-star-outline active"/></li>
                                                            </ul>
                                                        </div>
                                                    </li>
                                                    {/* <li className="list-inline-item">
                                                        <div className="info">
                                                            <em className="info_icon info_icon-blue gg-marker"/>
                                                            <span className="info_content">2.06 mi</span>
                                                        </div>
                                                    </li> */}
                                                </ul>
                                            </div>
                                        </div>   
                                        <div className="appointmentList_bottom d-flex">
                                            <Link to="/qanca-service-provider-details-miles" className=" btn btn-light w-100">MORE INFO</Link>
                                        </div>  
                                    </div>
                                </Col>
                                <Col sm={6} lg={4} xxl={3}>
                                    <div className="appointmentList position-relative">
                                        <div className="appointmentList_like">
                                            <Checkbox defaultChecked><em className="appointmentList_like_icon gg-heart-outline" /></Checkbox>
                                        </div>
                                        <div className="appointmentList_top d-flex align-items-start">
                                            <div className="appointmentList_top_images">
                                                <ImageElement source="img-2.png" />
                                            </div>
                                            <div className="appointmentList_top_content">
                                                <h2 className="font-md">Flynn Thwaites</h2>
                                                <p className="">Electrician</p>
                                                <ul className="list-inline mb-0">
                                                    <li className="list-inline-item">
                                                        <div className="info">
                                                           <ul className="list-unstyled d-flex starRating mb-0">
                                                                <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                                                <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                                                <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                                                <li className="starRating_halfStar"><em className="info_icon info_icon-gray gg-half-star active_half"/></li>
                                                                <li><em className="info_icon info_icon-gray gg-star-outline active"/></li>
                                                            </ul>
                                                        </div>
                                                    </li>
                                                    {/* <li className="list-inline-item">
                                                        <div className="info">
                                                            <em className="info_icon info_icon-blue gg-marker"/>
                                                            <span className="info_content">2.06 mi</span>
                                                        </div>
                                                    </li> */}
                                                </ul>
                                            </div>
                                        </div>   
                                        <div className="appointmentList_bottom d-flex">
                                            <Link to="/qanca-service-provider-details-miles" className=" btn btn-light w-100">MORE INFO</Link>
                                        </div>   
                                    </div>
                                </Col>
                                <Col sm={6} lg={4} xxl={3}>
                                    <div className="appointmentList position-relative">
                                        <div className="appointmentList_like">
                                            <Checkbox defaultChecked><em className="appointmentList_like_icon gg-heart-outline" /></Checkbox>
                                        </div>
                                        <div className="appointmentList_top d-flex align-items-start">
                                            <div className="appointmentList_top_images">
                                                <ImageElement source="img-3.png" />
                                            </div>
                                            <div className="appointmentList_top_content">
                                                <h2 className="font-md">Elijah Daws</h2>
                                                <p className="">Roofing</p>
                                                <ul className="list-inline mb-0">
                                                    <li className="list-inline-item">
                                                        <div className="info">
                                                           <ul className="list-unstyled d-flex starRating mb-0">
                                                                <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                                                <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                                                <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                                                <li className="starRating_halfStar"><em className="info_icon info_icon-gray gg-half-star active_half"/></li>
                                                                <li><em className="info_icon info_icon-gray gg-star-outline active"/></li>
                                                            </ul>
                                                        </div>
                                                    </li>
                                                    {/* <li className="list-inline-item">
                                                        <div className="info">
                                                            <em className="info_icon info_icon-blue gg-marker"/>
                                                            <span className="info_content">2.06 mi</span>
                                                        </div>
                                                    </li> */}
                                                </ul>
                                            </div>
                                        </div>   
                                        <div className="appointmentList_bottom d-flex">
                                            <Link to="/qanca-service-provider-details-miles" className=" btn btn-light w-100">MORE INFO</Link>
                                        </div>   
                                    </div>
                                </Col>
                                <Col sm={6} lg={4} xxl={3}>
                                    <div className="appointmentList position-relative">
                                        <div className="appointmentList_like">
                                            <Checkbox defaultChecked><em className="appointmentList_like_icon gg-heart-outline" /></Checkbox>
                                        </div>
                                        <div className="appointmentList_top d-flex align-items-start">
                                            <div className="appointmentList_top_images">
                                                <ImageElement source="img-4.png" />
                                            </div>
                                            <div className="appointmentList_top_content">
                                                <h2 className="font-md">Leo Monger</h2>
                                                <p className="">Plumbing</p>
                                                <ul className="list-inline mb-0">
                                                    <li className="list-inline-item">
                                                        <div className="info">
                                                           <ul className="list-unstyled d-flex starRating mb-0">
                                                                <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                                                <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                                                <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                                                <li className="starRating_halfStar"><em className="info_icon info_icon-gray gg-half-star active_half"/></li>
                                                                <li><em className="info_icon info_icon-gray gg-star-outline active"/></li>
                                                            </ul>
                                                        </div>
                                                    </li>
                                                    {/* <li className="list-inline-item">
                                                        <div className="info">
                                                            <em className="info_icon info_icon-blue gg-marker"/>
                                                            <span className="info_content">2.06 mi</span>
                                                        </div>
                                                    </li> */}
                                                </ul>
                                            </div>
                                        </div>   
                                        <div className="appointmentList_bottom d-flex">
                                            <Link to="/qanca-service-provider-details-miles" className=" btn btn-light w-100">MORE INFO</Link>
                                        </div>   
                                    </div>
                                </Col>
                                <Col sm={6} lg={4} xxl={3}>
                                    <div className="appointmentList position-relative">
                                        <div className="appointmentList_like">
                                            <Checkbox><em className="appointmentList_like_icon gg-heart-outline" /></Checkbox>
                                        </div>
                                        <div className="appointmentList_top d-flex align-items-start">
                                            <div className="appointmentList_top_images">
                                                <ImageElement source="img-5.png" />
                                            </div>
                                            <div className="appointmentList_top_content">
                                                <h2 className="font-md">Thorsten Roth</h2>
                                                <p className="">Plumbing</p>
                                                <ul className="list-inline mb-0">
                                                    <li className="list-inline-item">
                                                        <div className="info">
                                                           <ul className="list-unstyled d-flex starRating mb-0">
                                                                <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                                                <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                                                <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                                                <li className="starRating_halfStar"><em className="info_icon info_icon-gray gg-half-star active_half"/></li>
                                                                <li><em className="info_icon info_icon-gray gg-star-outline active"/></li>
                                                            </ul>
                                                        </div>
                                                    </li>
                                                    {/* <li className="list-inline-item">
                                                        <div className="info">
                                                            <em className="info_icon info_icon-blue gg-marker"/>
                                                            <span className="info_content">2.06 mi</span>
                                                        </div>
                                                    </li> */}
                                                </ul>
                                            </div>
                                        </div>   
                                        <div className="appointmentList_bottom d-flex">
                                            <Link to="/qanca-service-provider-details-miles" className=" btn btn-light w-100">MORE INFO</Link>
                                        </div>   
                                    </div>
                                </Col>
                                <Col sm={6} lg={4} xxl={3}>
                                    <div className="appointmentList position-relative">
                                        <div className="appointmentList_like">
                                            <Checkbox><em className="appointmentList_like_icon gg-heart-outline" /></Checkbox>
                                        </div>
                                        <div className="appointmentList_top d-flex align-items-start">
                                            <div className="appointmentList_top_images">
                                                <ImageElement source="img-1.png" />
                                            </div>
                                            <div className="appointmentList_top_content">
                                                <h2 className="font-md">Marko Loewe</h2>
                                                <p className="">HVAC</p>
                                                <ul className="list-inline mb-0">
                                                    <li className="list-inline-item">
                                                        <div className="info">
                                                           <ul className="list-unstyled d-flex starRating mb-0">
                                                                <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                                                <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                                                <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                                                <li className="starRating_halfStar"><em className="info_icon info_icon-gray gg-half-star active_half"/></li>
                                                                <li><em className="info_icon info_icon-gray gg-star-outline active"/></li>
                                                            </ul>
                                                        </div>
                                                    </li>
                                                    {/* <li className="list-inline-item">
                                                        <div className="info">
                                                            <em className="info_icon info_icon-blue gg-marker"/>
                                                            <span className="info_content">2.06 mi</span>
                                                        </div>
                                                    </li> */}
                                                </ul>
                                            </div>
                                        </div>   
                                        <div className="appointmentList_bottom d-flex">
                                            <Link to="/qanca-service-provider-details-miles" className=" btn btn-light w-100">MORE INFO</Link>
                                        </div>   
                                    </div>
                                </Col>
                                <Col sm={6} lg={4} xxl={3}>
                                    <div className="appointmentList position-relative">
                                        <div className="appointmentList_like">
                                            <Checkbox><em className="appointmentList_like_icon gg-heart-outline" /></Checkbox>
                                        </div>
                                        <div className="appointmentList_top d-flex align-items-start">
                                            <div className="appointmentList_top_images">
                                                <ImageElement source="img-2.png" />
                                            </div>
                                            <div className="appointmentList_top_content">
                                                <h2 className="font-md">Marko Junker</h2>
                                                <p className="">Handyman</p>
                                                <ul className="list-inline mb-0">
                                                    <li className="list-inline-item">
                                                        <div className="info">
                                                           <ul className="list-unstyled d-flex starRating mb-0">
                                                                <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                                                <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                                                <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                                                <li className="starRating_halfStar"><em className="info_icon info_icon-gray gg-half-star active_half"/></li>
                                                                <li><em className="info_icon info_icon-gray gg-star-outline active"/></li>
                                                            </ul>
                                                        </div>
                                                    </li>
                                                    {/* <li className="list-inline-item">
                                                        <div className="info">
                                                            <em className="info_icon info_icon-blue gg-marker"/>
                                                            <span className="info_content">2.06 mi</span>
                                                        </div>
                                                    </li> */}
                                                </ul>
                                            </div>
                                        </div>   
                                        <div className="appointmentList_bottom d-flex">
                                            <Link to="/qanca-service-provider-details-miles" className=" btn btn-light w-100">MORE INFO</Link>
                                        </div>   
                                    </div>
                                </Col>
                                <Col sm={6} lg={4} xxl={3}>
                                    <div className="appointmentList position-relative">
                                        <div className="appointmentList_like">
                                            <Checkbox><em className="appointmentList_like_icon gg-heart-outline" /></Checkbox>
                                        </div>
                                        <div className="appointmentList_top d-flex align-items-start">
                                            <div className="appointmentList_top_images">
                                                <ImageElement source="img-3.png" />
                                            </div>
                                            <div className="appointmentList_top_content">
                                                <h2 className="font-md">Marco Frey</h2>
                                                <p className="">Electrician</p>
                                                <ul className="list-inline mb-0">
                                                    <li className="list-inline-item">
                                                        <div className="info">
                                                           <ul className="list-unstyled d-flex starRating mb-0">
                                                                <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                                                <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                                                <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                                                <li className="starRating_halfStar"><em className="info_icon info_icon-gray gg-half-star active_half"/></li>
                                                                <li><em className="info_icon info_icon-gray gg-star-outline active"/></li>
                                                            </ul>
                                                        </div>
                                                    </li>
                                                    {/* <li className="list-inline-item">
                                                        <div className="info">
                                                            <em className="info_icon info_icon-blue gg-marker"/>
                                                            <span className="info_content">2.06 mi</span>
                                                        </div>
                                                    </li> */}
                                                </ul>
                                            </div>
                                        </div>   
                                        <div className="appointmentList_bottom d-flex">
                                            <Link to="/qanca-service-provider-details-miles" className=" btn btn-light w-100">MORE INFO</Link>
                                        </div>   
                                    </div>
                                </Col>
                                <Col sm={6} lg={4} xxl={3}>
                                    <div className="appointmentList position-relative">
                                        <div className="appointmentList_like">
                                            <Checkbox><em className="appointmentList_like_icon gg-heart-outline" /></Checkbox>
                                        </div>
                                        <div className="appointmentList_top d-flex align-items-start">
                                            <div className="appointmentList_top_images">
                                                <ImageElement source="img-4.png" />
                                            </div>
                                            <div className="appointmentList_top_content">
                                                <h2 className="font-md">Ralf Wirth</h2>
                                                <p className="">Roofing</p>
                                                <ul className="list-inline mb-0">
                                                    <li className="list-inline-item">
                                                        <div className="info">
                                                           <ul className="list-unstyled d-flex starRating mb-0">
                                                                <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                                                <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                                                <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                                                <li className="starRating_halfStar"><em className="info_icon info_icon-gray gg-half-star active_half"/></li>
                                                                <li><em className="info_icon info_icon-gray gg-star-outline active"/></li>
                                                            </ul>
                                                        </div>
                                                    </li>
                                                    {/* <li className="list-inline-item">
                                                        <div className="info">
                                                            <em className="info_icon info_icon-blue gg-marker"/>
                                                            <span className="info_content">2.06 mi</span>
                                                        </div>
                                                    </li> */}
                                                </ul>
                                            </div>
                                        </div>   
                                        <div className="appointmentList_bottom d-flex">
                                            <Link to="/qanca-service-provider-details-miles" className=" btn btn-light w-100">MORE INFO</Link>
                                        </div>   
                                    </div>
                                </Col>
                            </Row>
                        </div>                        
                    </Container>
                </div>
            </div>
            {/* booking details */}
            <Modal show={showbookdetail} onHide={bookdetailClose} size="lg" centered id="paidEmergency" className="bookingDetails" backdrop="static">
            <Modal.Header closeButton className="align-items-start">
                    <div>
                        <Modal.Title>Booking Details</Modal.Title>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Row className="align-items-center">
                            <Col lg={12} sm={12}>
                                <ul className="bookingDetails list-unstyled mb-0">
                                    <li className="bookingDetails_list d-flex">
                                        <label>Paid Schedule<br></br><strong>$100.00 x 1 (Quantity)</strong></label>
                                        <span className="font-sm">$100</span>
                                    </li>
                                    <li className="bookingDetails_list d-flex">
                                        <label>Booking Date</label>
                                        <span className="font-sm">Jan 24,2023</span>
                                    </li>
                                    <li className="bookingDetails_list d-flex">
                                        <label>Booking Time</label>
                                        <span className="font-sm">02:00 PM - 05:00 PM</span>
                                    </li>
                                </ul>
                            </Col>
                            {/* <Col lg={5} sm={12}>
                                <ul className="serviceCost list-unstyled mt-lg-0 mt-3 mb-0">
                                    <li className="serviceCost_list">
                                        <label>Service Cost</label>
                                        <span className="font-md">$128.98</span>
                                    </li>      
                                    <li className="serviceCost_list">
                                        <label>Promocode</label>
                                        <span className="font-md">-$30.00</span>
                                    </li>      
                                    <li className="serviceCost_list">
                                        <label>Total Cost</label>
                                        <span className="font-sm">$98.98</span>
                                    </li>      
                                </ul>
                            </Col> */}
                        </Row>
                        <div className="promoCode">
                            <Form className="d-flex align-items-end">
                                <FormGroup className="form-group promoCode_wrapper mb-0">
                                        <label className="ant-label font-md">Promo Code</label>
                                    <Input size="large" placeholder="Promo Code" value="NIT" />
                                </FormGroup>
                                <Button variant="primary" type="submit" className="ms-2 font-sm d-inline-block">APPLY</Button>
                            </Form>
                            {/* <div className="promoCode_info mt-2 d-flex align-items-center"><em className="gg-check-circle me-2"/> <span>Save $10</span></div> */}
                            <div className="promoCode_info mt-2 d-flex align-items-center"><em className="gg-check-circle me-2"/> <span>Promo Code applied!</span></div>
                        </div>
                        <div className="mb-3">
                            <ul className="serviceCost list-unstyled mt-lg-0 mt-3 mb-0">
                                <li className="serviceCost_list">
                                    <label>Total Cost</label>
                                    <span className="font-sm">$98.98</span>
                                </li>      
                            </ul>
                        </div>
                        <FormGroup className="form-group">
                            <label className="ant-label font-md ps-0">Add Special Instruction For Provider Below</label>
                            <TextArea rows={5} />
                        </FormGroup>
                        <div className="d-flex justify-content-end">
                            <Link className="ms-auto min-200 mt-lg-4 mt-3 btn btn-primary" onClick={() => RequestedShow()}>BOOKING CONFIRM</Link>
                        </div>
                    </Form>                   
                </Modal.Body>
            </Modal> 
              {/* booking requested */}
              <Modal show={showRequested} onHide={RequestedClose} size="lg" centered id="paidEmergency" className="paidEmergencymodel" backdrop="static">
                <Modal.Header closeButton className="align-items-start">
                    <div>
                        <Modal.Title>Booking Requested</Modal.Title>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div className="paidEmergency">
                        <p> Your provider has received the booking request and will get back to you shortly. You can check out the status of your request on the 'Your Bookings' menu item.</p>
                    </div>
                    <div className="d-flex justify-content-flex-end">    
                        <Link to="/my-bookings"  className="btn btn-primary ms-auto min-200">View BOOKING</Link>
                    </div>
                </Modal.Body>
            </Modal> 
        </>
    );
}

export default ServiceProviderList;